"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponsiveRescheduleModuleExample = exports.ResponsiveRescheduleModule = exports.ModalRescheduleModuleExample = exports.ModalRescheduleModule = exports.DrawerRescheduleModuleExample = exports.DrawerRescheduleModule = exports.DefaultRescheduleModuleArgs = void 0;
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
var __1 = require("..");
var user_config_1 = require("../../configs/user.config");
var enums_1 = require("../../shared/enums");
var use_forward_ref_1 = require("../../shared/helpers/use-forward-ref");
var solid_icon_definitions_1 = require("../il-icon/solid-icon-definitions");
var il_default_avatar_1 = require("../il-student-card/il-default-avatar");
var typeography_common_1 = require("../typeography/typeography.common");
var DefaultRescheduleModuleArgs = {
    students: __1.StudentFilterImplementationArgs,
    selectedStudent: __1.StudentFilterImplementationArgs[0],
    courses: __1.DefaultCoursePropsList,
    onSelectStudent: function () {
        return;
    },
    selectedCourse: __1.DefaultCoursePropsList[0],
    onSelectCourse: function () {
        return;
    },
    onSubmit: function (args) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, console.log(args)];
    }); }); },
};
exports.DefaultRescheduleModuleArgs = DefaultRescheduleModuleArgs;
function ModalRescheduleModule(_a) {
    var _b = _a.openState, openState = _b === void 0 ? false : _b, handleClose = _a.handleClose, props = __rest(_a, ["openState", "handleClose"]);
    return (react_1.default.createElement(material_1.Dialog, { onClose: handleClose, open: openState, maxWidth: "lg", fullWidth: true },
        react_1.default.createElement(__1.RescheduleModuleScreen, __assign({ headerRightComponent: react_1.default.createElement(material_1.IconButton, { onClick: handleClose, disableRipple: true, "data-testid": "close-icon", sx: {
                    py: 0,
                    mr: '0.75rem',
                } },
                react_1.default.createElement(__1.SolidIcon, { icon: solid_icon_definitions_1.SolidIconDefinitions.X_MARK_ICON })) }, props))));
}
exports.ModalRescheduleModule = ModalRescheduleModule;
function ModalRescheduleModuleExample(_a) {
    var _b = _a.openState, openState = _b === void 0 ? false : _b, props = __rest(_a, ["openState"]);
    var _c = react_1.default.useState(props.selectedCourse), selectedCourse = _c[0], setSelectedCourse = _c[1];
    var _d = react_1.default.useState(props.selectedStudent), selectedStudent = _d[0], setSelectedStudent = _d[1];
    function onSelectCourse(course) {
        setSelectedCourse(course);
        props.onSelectCourse && props.onSelectCourse(course);
    }
    function onSelectStudent(student) {
        setSelectedStudent(student);
        props.onSelectStudent && props.onSelectStudent(student);
    }
    var _e = react_1.default.useState(openState), open = _e[0], setOpen = _e[1];
    function handleClose() {
        setOpen(false);
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(__1.RescheduleButton, { onClick: function () { return setOpen(true); } }),
        react_1.default.createElement(ModalRescheduleModule, __assign({}, props, { selectedCourse: selectedCourse, selectedStudent: selectedStudent, onSelectCourse: onSelectCourse, onSelectStudent: onSelectStudent, openState: open, handleClose: handleClose, defaultFormValues: {
                schoolDays: selectedCourse === null || selectedCourse === void 0 ? void 0 : selectedCourse.weekdaySelections,
            } }))));
}
exports.ModalRescheduleModuleExample = ModalRescheduleModuleExample;
var DrawerRescheduleModule = react_1.default.forwardRef(function (_a, ref) {
    var drawerProps = _a.drawerProps, handleClose = _a.handleClose, props = __rest(_a, ["drawerProps", "handleClose"]);
    var innerRef = (0, use_forward_ref_1.useForwardRef)(ref);
    var hiddenCoursesButton = react_1.default.useRef(null);
    var hiddenRescheduleButton = react_1.default.useRef(null);
    var sx = __assign({ p: 2 }, props.sx);
    function ChildrenStudents(_a) {
        var onClose = _a.onClose;
        return (react_1.default.createElement(material_1.Box, { sx: sx },
            react_1.default.createElement(__1.ILStudentList, { showChevrons: true, showDividers: true, students: props.students, header: "Reschedule Work", onSelectStudent: function (student) {
                    var _a;
                    props.onSelectStudent(student);
                    (_a = hiddenCoursesButton === null || hiddenCoursesButton === void 0 ? void 0 : hiddenCoursesButton.current) === null || _a === void 0 ? void 0 : _a.click();
                    onClose && onClose();
                } })));
    }
    function ChildrenCourses(_a) {
        var _b;
        var onClose = _a.onClose;
        return (react_1.default.createElement(material_1.Box, { sx: sx },
            react_1.default.createElement(material_1.Box, { sx: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' } },
                react_1.default.createElement(material_1.Box, null,
                    react_1.default.createElement(material_1.IconButton, { "data-testid": "back-courses", disableRipple: true, sx: { p: 0 }, onClick: function () {
                            var _a;
                            (_a = innerRef === null || innerRef === void 0 ? void 0 : innerRef.current) === null || _a === void 0 ? void 0 : _a.click();
                            onClose && onClose();
                        } },
                        react_1.default.createElement(__1.SolidIcon, { icon: solid_icon_definitions_1.SolidIconDefinitions.CHEVRON_LEFT, size: enums_1.IconSizeEnum.SMALL }))),
                props.selectedStudent && (react_1.default.createElement(material_1.Box, { sx: { display: 'flex', gap: '0.5rem' } },
                    react_1.default.createElement(material_1.Avatar, { sx: { height: '1.5rem', width: '1.5rem' } },
                        react_1.default.createElement(il_default_avatar_1.ILDefaultAvatar, { color: (props.selectedStudent.avatar &&
                                user_config_1.userConfig.color[props.selectedStudent.avatar]) ||
                                props.selectedStudent.avatar })),
                    react_1.default.createElement(typeography_common_1.ILH3, null, (_b = props.selectedStudent) === null || _b === void 0 ? void 0 : _b.firstName))),
                react_1.default.createElement(material_1.Box, { sx: { width: '1.125rem' } })),
            react_1.default.createElement(material_1.Box, { sx: { mt: '1.5rem', display: 'flex', justifyContent: 'center' } },
                react_1.default.createElement(__1.ILActiveCourseList, { title: undefined, courses: props.courses, onClick: function (course) {
                        var _a;
                        props.onSelectCourse(course);
                        (_a = hiddenRescheduleButton === null || hiddenRescheduleButton === void 0 ? void 0 : hiddenRescheduleButton.current) === null || _a === void 0 ? void 0 : _a.click();
                        onClose && onClose();
                    }, sx: {
                        '& *': {
                            boxSizing: 'content-box',
                        },
                    } }))));
    }
    function ChildrenReschedule(_a) {
        var _this = this;
        var onClose = _a.onClose;
        return (react_1.default.createElement(material_1.Box, { sx: sx }, props.selectedCourse && (react_1.default.createElement(__1.RescheduleActivityForm, { dateStartYear: props.dateStartYear, dateEndYear: props.dateEndYear, defaultFormValues: props.defaultFormValues, activityDescription: props.selectedCourse.assignmentName, startedDate: props.selectedCourse.startDate, averageAssignmentsPerDay: props.averageAssignmentsPerDay, backComponent: react_1.default.createElement(material_1.IconButton, { disableRipple: true, "data-testid": "back-schedule", sx: { p: 0 }, onClick: function () {
                    var _a;
                    (_a = hiddenCoursesButton === null || hiddenCoursesButton === void 0 ? void 0 : hiddenCoursesButton.current) === null || _a === void 0 ? void 0 : _a.click();
                    onClose && onClose();
                } },
                react_1.default.createElement(__1.SolidIcon, { icon: solid_icon_definitions_1.SolidIconDefinitions.CHEVRON_LEFT, size: enums_1.IconSizeEnum.SMALL })), onSubmit: function (values) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (props === null || props === void 0 ? void 0 : props.onSubmit(values))];
                        case 1:
                            _a.sent();
                            onClose && onClose();
                            return [2 /*return*/];
                    }
                });
            }); } }))));
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(__1.ILTemporaryDrawer, { showClose: true, clickableComponent: react_1.default.createElement("button", { ref: innerRef, style: { display: 'none' } }, "Hidden students"), onCloseDrawer: function () {
                handleClose && handleClose();
            }, drawerProps: __assign({ PaperProps: {
                    sx: {
                        backgroundColor: 'background.default',
                    },
                } }, drawerProps) },
            react_1.default.createElement(ChildrenStudents, null)),
        react_1.default.createElement(__1.ILTemporaryDrawer, { showClose: true, clickableComponent: react_1.default.createElement("button", { ref: hiddenCoursesButton, style: { display: 'none' } }, "Hidden courses"), onCloseDrawer: function () {
                handleClose && handleClose();
            }, drawerProps: __assign({ PaperProps: {
                    sx: {
                        backgroundColor: 'background.default',
                    },
                } }, drawerProps) },
            react_1.default.createElement(ChildrenCourses, null)),
        react_1.default.createElement(__1.ILTemporaryDrawer, { showClose: true, clickableComponent: react_1.default.createElement("button", { ref: hiddenRescheduleButton, style: { display: 'none' } }, "Hidden reschedule"), onCloseDrawer: function () {
                handleClose && handleClose();
            }, drawerProps: __assign({ PaperProps: {
                    sx: {
                        backgroundColor: 'background.default',
                    },
                } }, drawerProps) },
            react_1.default.createElement(ChildrenReschedule, null))));
});
exports.DrawerRescheduleModule = DrawerRescheduleModule;
function DrawerRescheduleModuleExample(props) {
    var scheduleButton = react_1.default.useRef(null);
    var _a = react_1.default.useState(props.selectedCourse), selectedCourse = _a[0], setSelectedCourse = _a[1];
    var _b = react_1.default.useState(props.selectedStudent), selectedStudent = _b[0], setSelectedStudent = _b[1];
    function onSelectCourse(course) {
        setSelectedCourse(course);
        props.onSelectCourse && props.onSelectCourse(course);
    }
    function onSelectStudent(student) {
        setSelectedStudent(student);
        props.onSelectStudent && props.onSelectStudent(student);
    }
    function handleClick() {
        var _a;
        (_a = scheduleButton === null || scheduleButton === void 0 ? void 0 : scheduleButton.current) === null || _a === void 0 ? void 0 : _a.click();
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(__1.RescheduleButton, { onClick: handleClick }),
        react_1.default.createElement(DrawerRescheduleModule, __assign({}, props, { ref: scheduleButton, selectedCourse: selectedCourse, selectedStudent: selectedStudent, onSelectCourse: onSelectCourse, onSelectStudent: onSelectStudent, defaultFormValues: {
                schoolDays: selectedCourse === null || selectedCourse === void 0 ? void 0 : selectedCourse.weekdaySelections,
            } }))));
}
exports.DrawerRescheduleModuleExample = DrawerRescheduleModuleExample;
function ResponsiveRescheduleModule(_a) {
    var open = _a.open, onClose = _a.onClose, props = __rest(_a, ["open", "onClose"]);
    var ref = react_1.default.createRef();
    react_1.default.useEffect(function () {
        var _a;
        if (open) {
            (_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.click();
        }
    }, [ref, open]);
    var theme = (0, material_1.useTheme)();
    var showUpMd = (0, material_1.useMediaQuery)(theme.breakpoints.up('md'));
    return (react_1.default.createElement(react_1.default.Fragment, null,
        showUpMd && react_1.default.createElement(ModalRescheduleModule, __assign({ openState: open, handleClose: onClose }, props)),
        !showUpMd && react_1.default.createElement(DrawerRescheduleModule, __assign({ ref: ref, handleClose: onClose }, props))));
}
exports.ResponsiveRescheduleModule = ResponsiveRescheduleModule;
function ResponsiveRescheduleModuleExample(props) {
    var _a = react_1.default.useState(false), open = _a[0], setOpen = _a[1];
    var _b = react_1.default.useState(props.selectedCourse), selectedCourse = _b[0], setSelectedCourse = _b[1];
    var _c = react_1.default.useState(props.selectedStudent), selectedStudent = _c[0], setSelectedStudent = _c[1];
    function onSelectCourse(course) {
        setSelectedCourse(course);
        props.onSelectCourse && props.onSelectCourse(course);
    }
    function onSelectStudent(student) {
        setSelectedStudent(student);
        props.onSelectStudent && props.onSelectStudent(student);
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(__1.RescheduleButton, { onClick: function () { return setOpen(true); } }),
        react_1.default.createElement(ResponsiveRescheduleModule, __assign({ open: open, onClose: function () { return setOpen(false); } }, props, { selectedCourse: selectedCourse, selectedStudent: selectedStudent, onSelectCourse: onSelectCourse, onSelectStudent: onSelectStudent, defaultFormValues: {
                schoolDays: selectedCourse === null || selectedCourse === void 0 ? void 0 : selectedCourse.weekdaySelections,
            } }))));
}
exports.ResponsiveRescheduleModuleExample = ResponsiveRescheduleModuleExample;
